export default __webpack_public_path__ + "static/media/success.3068d1c1.svg";